import { Outlet } from "react-router-dom";
import { MarketingThemeScope } from "@/components/marketing/MarketingThemeScope";

/**
 * Single layout route that mounts MarketingThemeScope ONCE across all
 * marketing/public routes. Without this, every route had its own
 * `<MarketingThemeScope>` wrapper that unmounted on navigation, tearing
 * down the marketing token scope + mesh background for a frame and
 * causing a visible double-flash between marketing pages.
 */
export const MarketingLayout = () => (
  <MarketingThemeScope>
    <Outlet />
  </MarketingThemeScope>
);
